import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaintenanceNotificationComponent } from './components/maintenance-notification/maintenance-notification.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterOutlet, NgxUiLoaderModule, MaintenanceNotificationComponent]
})
export class AppComponent {
  title = 'transfercenter-download';
  getLang:any ='';

  constructor(
    public translate: TranslateService
  ) {

    const browserLang:any = translate.getBrowserLang();
    translate.addLangs(['en', 'jp']);

    //console.log('BROWSER DEFAULT LANG=============', browserLang);

    this.getLang = localStorage.removeItem('net_lang');
    this.getLang = localStorage.getItem('net_lang_new');

    if(this.getLang == '' || this.getLang == null){

      //console.log('Get lang empty');

      if(browserLang == 'ja' || browserLang == 'jp')
      {

        //console.log('Browser Lang JA');
        localStorage.setItem('net_lang_new','jp');
        translate.setDefaultLang('jp');
        translate.use('jp'); 
      }
      else
      {
        //console.log('Browser Lang EN for all');
        localStorage.setItem('net_lang_new','en');
        translate.setDefaultLang('en');
        translate.use('en'); 
      }
    }
    else {
      //console.log('Get lang have');
      translate.use(this.getLang);
    }
  }
}
